export enum BusinessAreaEnum {
  Mobility = 'Mobility',
  Travel = 'Travel'
}
